import classnames from 'classnames';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import { EProjectType } from '../../enums';
import { SingleProjectComponentsContent } from '../../models';
import { Carousel } from './Carousel';
import { EmbeddedVideo } from './EmbeddedVideo';
import { LongScreen } from './LongScreen/index';
import { MultiMedia } from './MultipleMedia/index';
import { SingleMedia } from './SingleMedia/index';
import { Text } from './Text';
import { TripleMedia } from './TripleMedia/index';

interface IProps {
    componentDetails: SingleProjectComponentsContent;
    onComponentDetailedClick: (src: string) => void;
    isLast: boolean;
}

export const ComponentWrapper: React.FC<IProps> = ({
    componentDetails,
    onComponentDetailedClick,
    isLast = false,
 }) => {
    const renderContent = (component: SingleProjectComponentsContent): JSX.Element | null => {
        let content: JSX.Element | null = null;

        switch (component.type) {
            case EProjectType.embedded_video:
                content = (
                    <EmbeddedVideo
                        content={component.content}
                        key={component.id}
                        setSelectedSrc={onComponentDetailedClick}
                    />
                );
                break;
            case EProjectType.long_screen:
                content = (
                    <LongScreen
                        content={component.content}
                        key={component.id}
                    />
                );
                break;
            case EProjectType.single_media:
                content = (
                    <SingleMedia
                        content={component.content}
                        key={component.id}
                        setSelectedSrc={onComponentDetailedClick}
                    />
                );
                break;
            case EProjectType.text:
                content = (
                    <Text
                        content={component.content}
                        key={component.id}
                        isLast={isLast}
                    />
                );
                break;
            case EProjectType.slider:
                content = (
                    <Carousel
                        setSelectedSrc={onComponentDetailedClick}
                        content={component.content}
                        key={component.id}
                    />
                );
                break;
            case EProjectType.multiple_media:
                content = (
                    <MultiMedia
                        setSelectedSrc={onComponentDetailedClick}
                        content={component.content}
                        key={component.id}
                    />
                );
                break;
            case EProjectType.triple_media:
                content = (
                    <TripleMedia
                        setSelectedSrc={onComponentDetailedClick}
                        content={component.content}
                        key={component.id}
                    />
                );
                break;
            default:
        }

        return content;
    };
    const [isVisible, setVisibility] = React.useState(false);

    return (
        <VisibilitySensor
            onChange={(isVisibleIn) => {
                if (isVisibleIn) {
                    setVisibility(true);
                }
            }}
            partialVisibility
        >
            <div className={classnames('project-section', { visible: isVisible })} >
                {renderContent(componentDetails)}
            </div>
        </VisibilitySensor>
    );
};
